import { useMemo } from "react";
import {
  selectQuickRecipes,
  selectInProgressCookingProgresses,
  THIRTY_MINUTES,
  useT,
  useAppSelector,
} from "@reciperoll/core";
import { Zap } from "react-feather";
import { RecipeRail } from "./RecipeRail";

// Recipes cookable in 30 minutes or less.
export default function QuickRecipes() {
  const t = useT();
  const selectQuick = useMemo(() => selectQuickRecipes(THIRTY_MINUTES), []);
  const recipes = useAppSelector(selectQuick);
  const cookingIds = new Set(
    useAppSelector(selectInProgressCookingProgresses).map((cp) => cp.recipeId),
  );

  return (
    <RecipeRail
      title={t("home.quickRecipes")}
      icon={<Zap className="w-5 h-5" />}
      eyebrow={t("home.quickRecipesEyebrow")}
      link="/quick-recipes"
      recipes={recipes}
      cookingIds={cookingIds}
    />
  );
}
